export const siteLinks = {
  termsAndConditions:
    'https://tmr.hospitalityleaders.com/tos/HL_TMR_Terms_of_Service_v1_HA170510.pdf',
  music: 'https://music.holedo.com',
};
